import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Award, Loader2, Building2, Clock } from "lucide-react";
import PageHeader from "../components/PageHeader";
import ContactCTA from "../components/ContactCTA";
import { caseStudiesApi } from "../lib/api";

const CaseStudiesPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    caseStudiesApi.listPublic().then(setItems).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <PageHeader
        title="Case Studies & Success Stories"
        subtitle="Real ISO certification journeys with real outcomes  from automotive tier-1 suppliers to fast-growing SaaS companies and laboratories."
        crumbs={[{ label: "Case Studies" }]}
      />

      <section className="section-pad bg-white">
        <div className="lis-container">
          {loading ? (
            <div className="flex items-center gap-2 text-slate-500 py-16"><Loader2 className="animate-spin"/> Loading...</div>
          ) : items.length === 0 ? (
            <div className="text-center py-20 text-slate-500">No case studies published yet.</div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((c) => (
                <Link key={c.slug} to={`/case-studies/${c.slug}`} className="rounded-2xl overflow-hidden border border-slate-100 bg-white card-hover flex flex-col group">
                  <div className="relative h-52 overflow-hidden">
                    {c.image && <img src={c.image} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
                    <span className="absolute top-3 left-3 chip"><Award size={12}/> {c.standard}</span>
                  </div>
                  <div className="p-6 flex-1 flex flex-col">
                    <div className="flex flex-wrap items-center gap-3 text-xs text-slate-500">
                      {c.industry && <span className="flex items-center gap-1"><Building2 size={12}/> {c.industry}</span>}
                      {c.duration && <span className="flex items-center gap-1"><Clock size={12}/> {c.duration}</span>}
                    </div>
                    <h3 className="mt-3 text-lg font-bold text-slate-900 leading-snug">{c.title}</h3>
                    <p className="mt-2 text-sm text-slate-600 flex-1 line-clamp-3">{c.outcome_summary || c.challenge}</p>
                    <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand">
                      Read the story <ArrowRight size={14} />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      <ContactCTA />
    </>
  );
};

export default CaseStudiesPage;
